<a
  class="product-suggestion"
  [routerLink]="[appStorefrontProductRoute, product.id]"
  [attr.mmTestId]="'PRODUCT_SUGGESTION.PRODUCT_CARD'"
  (click)="onProductClick()"
>
  <div class="product-suggestion__image-container">
      <img [appDefaultImage]="defaultProductImage" class="product-suggestion__image"
           [alt]="product.name" [appLazyLoadImage]="product.image">
  </div>
  <p
    class="product-suggestion__title"
    [mmTestTarget]="'product-suggestion-' + product?.name | kebabCase"
  >
    {{product.name}}
  </p>
  <div class="product-suggestion__price-box">
    <ng-container *ngIf="product?.bestOffer as bestOffer; else registerPlaceholder">
      <div class="product-suggestion__price">
        <span *ngIf="(product.hasPromotion && bestOffer?.referencePrice)" class="product-suggestion__strikethrough-price">
          <span class="product-suggestion__strikethrough-price__text">
            {{'CATALOG.CATALOG_PAGE.PRODUCT.STRIKETHROUGH_PRICE' | translate}}
          </span>
          <span class="product-suggestion__strikethrough-price__amount">
            {{ (showNetPrice ? bestOffer.referencePrice?.netPrice : bestOffer.referencePrice?.grossPrice) | currency: bestOffer.referencePrice?.currency}}
          </span>
        </span>
        <span class="product-suggestion__primary-price"
              [ngClass]="{ 'product-suggestion__primary-price--promotion': product?.hasPromotion && bestOffer?.referencePrice }">
          {{ (showNetPrice ? product.bestOffer?.price?.netPrice : product.bestOffer?.price?.grossPrice) | currency: product.bestOffer?.price?.currency }}
        </span>
      </div>
      <div class="product-suggestion__tax-price" *ngIf="showNetPrice && bestOffer?.price as price">
        {{ 'CATALOG.CATALOG_PAGE.PRODUCT.VAT_LABEL' | translate }}
        {{ price?.netPrice | currency: price?.currency }}
      </div>
    </ng-container>
  </div>
</a>

<ng-template #registerPlaceholder>
  <span
    class="product-card__hidden-price">{{ 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.B2B_OFFER_ONLY.LABEL' | translate }}</span>
</ng-template>
